/**
 * @file
 *
 * This file describes only the 'Action Types' and his 'Actions Creators'
 * https://redux.js.org/docs/basics/Actions.html
 * @author JPablo
 */

/*
* Action Types
*/
import {FiltroReporte} from "../modelo/Reporte";
import {Documento, TrazaEstado} from "../../documentos/modelo/Documento";
import { FiltroHistoricos } from "../modelo/Historicos";

export const CONSULTAR_REPORTE = "CONSULTAR_REPORTE";
export const REPORTE_CONSULTADO = "REPORTE_CONSULTADO";
export const ERROR_CONSULTANDO_REPORTE = "ERROR_CONSULTANDO_REPORTE";

export const CONSULTAR_HISTORICO = "CONSULTAR_HISTORICO";
export const HISTORICO_CONSULTADO = "HISTORICO_CONSULTADO";
export const ERROR_CONSULTANDO_HISTORICO = "ERROR_CONSULTANDO_HISTORICO";

export const OBTENER_XLS_REPORTE = "OBTENER_XLS_REPORTE";
export const OBTENER_XLS_HISTORICO = "OBTENER_XLS_HISTORICO";
export const XLS_OBTENIDO = "XLS_OBTENIDO";
export const ERROR_OBTENIENDO_XLS = "ERROR_OBTENIENDO_XLS";

/*
* Actions Creators
* Note that's a good practice type the Action fields {..., name: name} instead of {..., name}
*/
export const consultarReporte = (filtroReporte: FiltroReporte) => ({type: CONSULTAR_REPORTE, filtro: filtroReporte});
export const consultarHistorico = (filtroHistorico: FiltroHistoricos) => ({type: CONSULTAR_HISTORICO, filtro: filtroHistorico});
export const reporteConsultado = (documentos: Array<Documento>,paginas:number) => ({type: REPORTE_CONSULTADO, documentos, paginas});
export const historicoConsultado = (estados: Array<TrazaEstado>,paginas : number) => ({type: HISTORICO_CONSULTADO, estados, paginas});
export const errorConsultandoReporte = () => ({type: ERROR_CONSULTANDO_REPORTE});
export const errorConsultandoHistorico = () => ({type: ERROR_CONSULTANDO_HISTORICO});

export const obtenerXLSReporte = (filtroReporte: FiltroReporte) => ({type: OBTENER_XLS_REPORTE, filtro: filtroReporte});
export const obtenerXLSHistorico = (filtroHistoricos: FiltroHistoricos) => ({type: OBTENER_XLS_HISTORICO, filtro: filtroHistoricos});
export const xlsObtenido = () => ({type: XLS_OBTENIDO});
export const errorObteniendoXLS = () => ({type: ERROR_OBTENIENDO_XLS});


// WEBPACK FOOTER //
// ./src/co/sura/dominio/reportes/modulos/reportesActions.ts